import { z } from 'zod';
import { dataGridSearchFields } from '@/features/dynamic-table';
import { ALERT_CATEGORY_KEYS } from './-constants';
export const AlertViewMode = {
  INDIVIDUAL: 'individual',
  ITEM: 'item'
} as const;
export type AlertViewMode = (typeof AlertViewMode)[keyof typeof AlertViewMode];
export const EquipmentAlertsSearchSchema = z.object({
  ...dataGridSearchFields,
  viewMode: z.enum(['individual', 'item']).default(AlertViewMode.INDIVIDUAL),
  category: z.enum(ALERT_CATEGORY_KEYS).default('REPLACEMENT_DUE'),
  freeText: z.string().optional()
});